<template>

  <div>
    <button class="btn-4 w-100">
      <div class="text-right">
        <div class="overflow-hidden button-entry">
          <v-img
              class="image-zoom"
              style="margin: 12px"
              cover
              height="300"
              :src="item.photo_file"></v-img>
        </div>

        <div class="pa-4">
          <p class="px-4 font-weight-bold my-4">
            {{ item.title }}
          </p>
          <v-row v-for="(field,index) in item.fields"
                 :key="index" class="pb-2"
                 v-if="field.type!==9"
          >
            <v-col cols="8" class="pr-4 font-weight-bold">{{ field.title }}</v-col>
            <v-col cols="4" style="font-size: 14px">
              <div v-if="field.type===9" class="app-small-btn" @click="downloadImage(field.value, field.title)">
                {{ $t('download') }}
              </div>
              <div v-else> {{ field.value }}</div>
            </v-col>
          </v-row>
          <v-row  :justify="$vuetify.breakpoint.smAndDown?'center':'end'" class="mt-4">
            <v-col
                  v-if="item.attach_file"
                 class="pb-2"
                
                cols="6">
              <div class="app-small-btn" @click="downloadImage(item.attach_file, item.title)">
                
                {{ $t('download') }} 
              </div>
            </v-col>
            <v-col
                v-for="(field,index) in item.fields"
                :key="index" class="pb-2"
                v-if="field.type===9&&field.title!=='اسناد تخصصی'"
                cols="6">
              <div class="app-small-btn" @click="downloadImage(field.value, field.title)">
                
                {{ $t('download') }} {{ field.title }}
              </div>
            </v-col>
          </v-row>
        </div>
        <span class="right-border"></span>
        <span class="left-border"></span>
      </div>
    </button>
  </div>


</template>
<script>
export default {
  name: 'TrendItem',
  props: {
    item: {}
  },
  methods: {
    downloadImage(url, name) {
      // url=`//uploads/topics/${url}`;
      fetch(url)
          .then(resp => resp.blob())
          .then(blob => {
            
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(() => alert('An error sorry'));
    },
  }
}
</script>

<style scoped>
p {
  text-decoration: none;
}

button {
  display: inline-block;
  position: relative;
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: auto;
}

.right-border {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100px;
  height: 100px;
  border-right: 10px solid #f3c303;
  border-bottom: 10px solid #f3c303;
}

.left-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  border-left: 10px solid #f3c303;
  border-top: 10px solid #f3c303;
  z-index: 97;
}


button::before, button::after {
  content: "";
  width: 0;
  height: 10px;
  position: absolute;
  transition: all 0.4s linear;
  background: #FCC300;
  z-index: 97;
}

.button-entry::before, .button-entry::after {
  content: "";
  width: 10px;
  height: 0;
  position: absolute;
  transition: all 0.4s linear;
  background: #FCC300;
  z-index: 97;
}

button:hover::before, button:hover::after {
  width: 100%;
}

button:hover .button-entry::before, button:hover .button-entry::after {
  height: 100%;
}


/*----- button 4 -----*/
.btn-4::after {
  right: 0;
  bottom: 0;
  transition-duration: 0.4s;
}

.btn-4 .button-entry::after {
  right: 0;
  bottom: 0;
  transition-duration: 0.4s;
}

.btn-4::before {
  left: 0;
  top: 0;
  transition-duration: 0.4s;
}

.btn-4 .button-entry::before {
  left: 0;
  top: 0;
  transition-duration: 0.4s;
}

*, *:after, *:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
</style>

